const scheduleFrame: (cb: () => void) => void =
  typeof window !== 'undefined' && window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : (cb) => {
        setTimeout(cb, 1);
      };

export function asyncFrame<T>(callback: () => T | Promise<T>): Promise<T> {
  return new Promise<T>((resolve) => {
    scheduleFrame(() => resolve(callback()));
  });
}
